import api from "../api"
import { auth, patient, doctor } from "../api_endpoints" 
  const token = localStorage.getItem("token") 

export const checkByAadhaar=async(data)=>{
    const aadhaar_id=data
    try {
        const response=await api.post(auth.checkUserByAdhaar,{aadhaar_id})
        return response.response
    } catch (error) {
        throw error.response
    }
}

export const sendOtp=async(data)=>{
    const mobile=data
    try {
        const response=await api.post(auth.sendOtp,{mobile,requester:"Doctor"})
        return response
    } catch (error) {
        throw error
    }
}

export const loginDoctor=async(data)=>{
    const {mobile,aadhaar_id,device_token,otp}=data
    try {
        const response=await api.post(auth.loginDoctor,{mobile,aadhaar_id,device_token,otp})
        return response
    } catch (error) {
        throw error
    }
}

export const createDoctor=async(data)=>{
    const {first_name,last_name,aadhaar_id,email,gender,profile_image,primary_number,dob,license_number,specialist_type,experience_years}=data
    const formData = new FormData()
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("aadhaar_id", aadhaar_id);
    formData.append("email", email);
    formData.append("gender", gender);
    formData.append("profile_image", profile_image);
    formData.append("primary_number", primary_number);
    formData.append("dob", dob);
    formData.append("license_number", license_number);
    formData.append("specialist_type", specialist_type);
    formData.append("experience_years", experience_years);

    try {
        const response=await api.post(auth.createDoctor,formData,{
             headers: {
          "Content-Type": "multipart/form-data",
        },
        })
        return response
    } catch (error) {
        throw error
    }
}

export const patientMapCheck=async(data)=>{
    let token=data.token
    try {
        const response=await api.post(patient.checkMap,{aadhaar_id:data.aadhaar_id},{
    headers: {
      Authorization: `Bearer ${token}`,    
        }})
        return response
    } catch (error) {
      throw error
    }
}

export const getPatientMapped=async(token)=>{
    try {
        const response=await api.get(patient.getmappedPatient,{
    headers: {
      Authorization: `Bearer ${token}`,    
        }})
        return response
    } catch (error) {
      throw error
    }
}

export const sendOtpPatientMapping=async(data)=>{
    let token=data.token
    try {
        const response=await api.post(patient.patientMappingOtpSend,
            {patient_user_id:data.id,
            relationship_type:"primary doctor"
        },{
    headers: {
      Authorization: `Bearer ${token}`,    
        }})
        return response
    } catch (error) {
      throw error
    }
}

export const verifyOtpPatientMapping=async(data)=>{
    let token=data.token
    try {
        const response=await api.post(patient.createmAPPINGvERIFY,
            {patient_user_id:data.id,
            relationship_type:"primary doctor",
            otp:data.otp
        },{
    headers: {
      Authorization: `Bearer ${token}`,    
        }})
        return response
    } catch (error) {
      throw error
    }
}

export const uploadReportByDoc=async(data)=>{
    const{token,user_id,report_type,report_date,uploaded_person_name,report_summary,report_file}=data
    const formData = new FormData()
    formData.append('user_id',user_id)
    formData.append('report_type',report_type)
    formData.append('report_date',report_date)
    formData.append('uploaded_person_name',uploaded_person_name)
    formData.append('report_summary',report_summary)
    formData.append('report_file',report_file)

    console.log(data);
   
    try {
        const res=await api.post(patient.uploadReport,formData,{
            headers: {
          "Authorization": `Bearer ${token}`, 
          "Content-Type": "multipart/form-data", 
        },
        })
        return res
    } catch (error) {
        throw error
    }
}

export const getAllHospitals = async () => {
    try {
        const response = await api.get(doctor.getAllHospitals,  {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
        return response
    } catch (error) {
        throw error
    }
}

export const getAllDiagnostics = async () => {
    try {
        const response = await api.get(doctor.getAllDiagnocs,  {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
        return response
    } catch (error) {
        throw error
    }
}

export const getAllHospitalRequest = async () => {
    try {
        const response = await api.get(doctor.getHospitalRequests,  {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
        return response
    } catch (error) {
        throw error
    }
}

export const getAllDiagnosticRequest = async () => {
    try {
        const response = await api.get(doctor.getDiagnosticRequests,  {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
        return response
    } catch (error) {
        throw error
    }
}

export const approveHospitalRequest = async (data) => {
    try {
        const response = await api.put(doctor.approaveHospitalRequest,data,  {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
        return response
    } catch (error) {
        throw error
    }
}


export const createHospitalMapping = async (data) => {
    // Destructure whatever names you are passing
    const { hospital_id, doctor_user_id, token } = data
    

    const payload = { 
        doctor_user_id: doctor_user_id,
        // Send as hospital_user_id if that's what your specific API wants (based on your success response)
        hospital_user_id: hospital_id, 
      
      
    };
    console.log(payload);
    

    try {
        const response = await api.post(doctor.requestDoctorHospitalMapping, 
            payload, 
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return response
    } catch (error) {
        throw error
    }
}

export const getDoctorProfile=async(token)=>{
    
    try {
        console.log(token);
        
        const response=await api.get(auth.getprofile,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}